export default {
  // index.tsx columns
  "dailyReports.thead.statisticsTimeDesc": "Statistics Date",
  "dailyReports.thead.statisticsTimeFrom": "Start Time",
  "dailyReports.thead.statisticsTimeTo": "End Time",
  "dailyReports.thead.statisticsType": "Report Period",
  "dailyReports.thead.statisticsType.day": "Day",
  "dailyReports.thead.statisticsType.week": "Week",
  "dailyReports.thead.statisticsType.month": "Month",
  "dailyReports.thead.statisticsType.year": "Year",
  "dailyReports.thead.totalRegisterUser": "Register",
  "dailyReports.thead.totalFirstDeposit": "First Deposit Users",
  "dailyReports.thead.totalDepositUser": "Total Deposit\nUsers",
  "dailyReports.thead.userTransferRatio": "Conversion Rate",
  "dailyReports.thead.totalActiveUser": "Active",
  "dailyReports.thead.totalFirstDepositAmount": "First Deposit",
  "dailyReports.thead.totalDepositAmount": "Deposit",
  "dailyReports.thead.totalWithdrawAmount": "Withdraw",
  "dailyReports.thead.depositSubWithdrawAmount": "Deposit-Withdraw",
  "dailyReports.thead.depositSubWithdrawAmount.tooltip.deposit": "Deposit is {green}",
  "dailyReports.thead.depositSubWithdrawAmount.tooltip.withdraw": "Withdraw is {red}",
  "dailyReports.thead.totalBetUser": "Bet Users",
  "dailyReports.thead.totalRealBetAmount": "Real Bet Amount",
  "dailyReports.thead.totalWinAmount": "Total Win Amount",
  "dailyReports.thead.totalPayoutAmount": "Game Payout",
  "dailyReports.thead.totalPayoutAmount.tooltip": "Negative payout means platform profit",
  "dailyReports.thead.totalPayoutAmount.tooltip.profit": "Profit is {green}",
  "dailyReports.thead.totalPayoutAmount.tooltip.loss": "Loss is {red}",
  "dailyReports.thead.totalPromotionAmount": "Promotion Bonus",
  "dailyReports.thead.claimCashbackAmount": "Claimed Cashback",
  "dailyReports.thead.totalCheckinNum": "Total Check-in",
  "dailyReports.thead.todayRegisterCheckinNum": "Today Check-in",
  "dailyReports.thead.historyRegisterCheckinNum": "History Check-in",
  "dailyReports.thead.totalAdminAmount": "Adjustment",
  "dailyReports.thead.totalBalanceAmount": "Platform Balance",
  "dailyReports.thead.totalGainAmount": "Profit/Loss",
  "dailyReports.thead.totalGainAmount.tooltip": "Game win/loss - Promotion - Cashback - Adjustment - Bonus = Profit/Loss",
  "dailyReports.thead.totalGainAmount.tooltip.profit": "Profit is {green}",
  "dailyReports.thead.totalGainAmount.tooltip.loss": "Loss is {red}",
  "dailyReports.thead.totalBalanceAmountSub": "Balance Diff",
  "dailyReports.thead.modifyTime": "Update Time",
  "dailyReports.thead.detail": "Detail",
  "dailyReports.thead.detail.games": "Detail",
  "dailyReports.copy.success": "Copy Success!",
  "dailyReports.loading": "Loading...",

  // BetStatisticsForGame modal
  "dailyReports.betStatistics.title": "Bet Statistics For Game",
  "dailyReports.betStatistics.gameId": "Game ID",
  "dailyReports.betStatistics.gameName": "Game Name",
  "dailyReports.betStatistics.providerId": "Provider ID",
  "dailyReports.betStatistics.providerName": "Provider Name",
  "dailyReports.betStatistics.betNum": "Bet Count",
  "dailyReports.betStatistics.totalBetAmount": "Total Bet Amount",
  "dailyReports.betStatistics.totalResultAmount": "Total Result Amount",
  "dailyReports.betStatistics.totalWinAmount": "Total Win Amount",
  "dailyReports.betStatistics.summary": "Summary",

  // ExpandedRows titles & thead
  "dailyReports.expanded.thirdPartyBet": "Third-party Bet",
  "dailyReports.expanded.thirdPartyBet.gameType": "Game Type",
  "dailyReports.expanded.thirdPartyBet.platform": "Platform",
  "dailyReports.expanded.thirdPartyBet.betAmount": "Bet",
  "dailyReports.expanded.thirdPartyBet.realBetAmount": "Valid Bet",
  "dailyReports.expanded.thirdPartyBet.betUserNum": "Bet Users",
  "dailyReports.expanded.thirdPartyBet.payout": "Payout",
  "dailyReports.expanded.thirdPartyBet.betOrderNum": "Bet Orders",
  "dailyReports.expanded.thirdPartyBet.totalSummary": "Third-party Total",
  "dailyReports.expanded.summary": "Summary",

  "dailyReports.expanded.thirdPartyDeposit": "Third-party Deposit",
  "dailyReports.expanded.thirdPartyDeposit.platform": "Third-party Payment",
  "dailyReports.expanded.thirdPartyDeposit.amount": "Deposit Total",
  "dailyReports.expanded.thirdPartyDeposit.orderNum": "Deposit Count",

  "dailyReports.expanded.thirdPartyWithdraw": "Third-party Withdraw",
  "dailyReports.expanded.thirdPartyWithdraw.platform": "Third-party Payment",
  "dailyReports.expanded.thirdPartyWithdraw.amount": "Withdraw Total",
  "dailyReports.expanded.thirdPartyWithdraw.orderNum": "Withdraw Count",

  "dailyReports.expanded.promotion": "Promotion",
  "dailyReports.expanded.promotion.discountType": "Discount Type",
  "dailyReports.expanded.promotion.content": "Discount Content",
  "dailyReports.expanded.promotion.amount": "Discount Amount",
  "dailyReports.expanded.promotion.depositDiscount": "Deposit Discount",
  "dailyReports.expanded.promotion.activityDiscount": "Activity Discount",

  "dailyReports.expanded.cashback": "Cashback",
  "dailyReports.expanded.cashback.content": "Cashback Content",
  "dailyReports.expanded.cashback.amount": "Cashback Amount",

  "dailyReports.expanded.manualDeposit": "Manual Deposit",
  "dailyReports.expanded.manualDeposit.type": "Deposit Type",
  "dailyReports.expanded.manualDeposit.amount": "Deposit Total",
};
